/**
 * Whether #pageForm should have `.editing-mode` after a form-editing switch interaction.
 *
 * Must mirror the checkbox checked state — never toggle relative to the previous class.
 * Blind toggleClass() desyncs when the page loads with ?editing=1 (switch ON, class absent)
 * or after any other mismatch between Switchery and the form class.
 *
 * @param {{ switchChecked: boolean|number|string|null|undefined, previouslyEnabled?: boolean }} state
 * @returns {boolean}
 */
export function resolveFormEditingModeEnabled({ switchChecked }) {
	return Boolean(switchChecked);
}
